import { apiFetch } from "@/api/client";

export interface AuditLogEntry {
  id: number;
  actor_username: string;
  action: string;
  target: string | null;
  params: Record<string, unknown> | null;
  exit_code: number | null;
  ip_address: string | null;
  created_at: string;
}

export interface AuditLogListResponse {
  items: AuditLogEntry[];
  total: number;
  page: number;
  page_size: number;
}

export const listAuditLog = (params: { actor?: string; action?: string; page: number }) => {
  const q = new URLSearchParams({ page: String(params.page), page_size: "50" });
  if (params.actor) q.set("actor", params.actor);
  if (params.action) q.set("action", params.action);
  return apiFetch<AuditLogListResponse>(`/audit-log?${q.toString()}`);
};
